import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import List from './list';
import R from 'ramda';
const propTypes = {
  list: PropTypes.object,
  selectedContracts: PropTypes.array,
  actionsForContract: PropTypes.object,
  className: PropTypes.string,
  showFolder: PropTypes.bool,
  hoveringOverContractId: PropTypes.string,
  selectCurrentAll: PropTypes.func,
  unselectAll: PropTypes.func,
  searchingAllYears: PropTypes.bool,
  contractPeriods: PropTypes.array,
  updateCurrentYear: PropTypes.func,
  updateSearchParams: PropTypes.func,
  currentYear: PropTypes.object,
  sortValue: PropTypes.string,
  sortRule: PropTypes.number,
  assignee: PropTypes.string,
  companyType: PropTypes.string,
};

class ContractList extends Component {
  shouldComponentUpdate(nextProps) {
    const propKeys = R.keys(propTypes).filter(key => propTypes[key] !== PropTypes.func && key !== 'actionsForContract');
    return !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps));
  }
  render() {
    return (<List {...this.props} />);
  }
}


const mapStateToProps = ({ contracting, user }) => ({
  currentYear: contracting.currentYear,
  contractPeriods: contracting.contractPeriods,
  list: contracting.contractList.get('list').toJS(),
  searchingAllYears: contracting.contractList.getIn(['searchParams', 'searchingAllYears']),
  selectedContracts: contracting.contractList.get('selectedContracts').toJS(),
  sortValue: contracting.contractList.getIn(['searchParams', 'sortValue']),
  sortRule: contracting.contractList.getIn(['searchParams', 'sortRule']),
  assignee: contracting.contractList.getIn(['searchParams', 'assignee']),
  priority: contracting.contractList.getIn(['searchParams', 'priority']),
  sentContractsCount: user.get('sentContractsCount'),
  companyType: user.getIn(['company', 'companyType']),
});
ContractList.propTypes = propTypes;
export default connect(mapStateToProps, { updateCurrentYear: (dates) => ({ type: '[contracting]SELECTED_YEAR_FOR_CONTRACTING', payload: dates }), push })(ContractList);



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-list/list/listContainer.jsx